import { render, staticRenderFns } from "./addfankui.vue?vue&type=template&id=0e6c1130&scoped=true"
import script from "./addfankui.vue?vue&type=script&lang=js"
export * from "./addfankui.vue?vue&type=script&lang=js"
import style0 from "./addfankui.vue?vue&type=style&index=0&id=0e6c1130&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6c1130",
  null
  
)

export default component.exports